module.exports = __webpack_public_path__ + "img/type_number_icon.3da239ad.svg";